import React, { Component } from "react";
import "./errorField.css";

export default function ErrorField(props) {
  return (
    <div className="error-field">{props.children}</div>
  )
}